import ImpactContent from "./ImpactContent";
import ImpactCards from "./ImpactCards";

function WarehouseImpactSection() {
  return (
    <section className="impact-section pt-5 mb-30">
      <div className="container">
        <div className="row align-items-center gy-5">

          {/* LEFT CONTENT */}
          <div className="col-lg-6">
            <ImpactCards />
          </div>

          {/* RIGHT BOXES */}
          <div className="col-lg-6">
            <ImpactContent />
          </div>
        </div>
      </div>
      <div className=" text-danger py-4 px-5">
        <hr className="w-100 opacity-100" style={{ borderColor: "rgba(9, 26, 58, 1)" }} />
      </div>
    </section>
  );
}

export default WarehouseImpactSection;
